import {convertWidthToPx, getDefaultWidth} from '../converters/width'
import {CANVAS_WIDTH} from '../constants'
import type {CalculateParams} from '../types'
import {getParentWidth, getValue, isPage, isSection, reportCalculationError, reportEndlessLoopError} from '../utils'

const widthCalculationInProgress = new Set<string>()

export const calculateWidth = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, extensionAPI, compRef, layoutData} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.width(compRef) !== undefined) {
        return
    }

    if (widthCalculationInProgress.has(compRef.id)) {
        set.width(compRef, getDefaultWidth(calculateParams))
        reportEndlessLoopError(calculateParams)
        return
    }

    widthCalculationInProgress.add(compRef.id)
    try {
        const {componentLayout} = layoutData
        const {width} = componentLayout ?? {}

        if (isSection(extensionAPI, compRef) || isPage(extensionAPI, compRef)) {
            set.width(compRef, CANVAS_WIDTH)
        } else if (!width?.type) {
            set.width(compRef, getParentWidth(calculateParams))
        } else {
            const widthInPx = convertWidthToPx[width.type]({
                ...calculateParams,
                value: getValue(width)
            })
            set.width(compRef, widthInPx)
        }
    } catch (error) {
        set.width(compRef, getDefaultWidth(calculateParams))
        reportCalculationError(calculateParams)
    } finally {
        widthCalculationInProgress.delete(compRef.id)
    }
}
